export interface ListPanelState {
    isLoading: boolean;
    isError: boolean;
    hasFocusableAction: boolean;
    lastPage: number | undefined;
}

/** The panel is a tab stop only when nothing inside it can take focus. */
export const isListPanelFocusable = ({ isLoading, isError, hasFocusableAction, lastPage }: ListPanelState): boolean => {
    if (hasFocusableAction || isError) return false;
    if (isLoading) return true;

    return (lastPage ?? 1) <= 1;
};
